import React from 'react';

import CustomTableWithLoadMore from './CustomTableWithLoadMore';
import CustomTableWithPagination from './CustomTableWithPagination';

export const CustomTableVariants = {
    WITH_LOAD_MORE: 'withLoadMore',
    WITH_PAGINATION: 'withPagination',
    WITHOUT_PAGINATION: 'withoutPagination',
};

const CustomTable = ({
    columns,
    rows,
    title,
    defaultSortFieldId,
    onClickLoadMore,
    customRowsPerPage = 10,
    defaultOrder = 'desc',
    rowHeight,
    variant = CustomTableVariants.WITH_PAGINATION,
    tableSx = {},
}) => {
    if (!rows || rows.length === 0 || !columns || columns.length === 0) {
        return null;
    }

    if (variant === CustomTableVariants.WITH_LOAD_MORE) {
        return (
            <CustomTableWithLoadMore
                columns={columns}
                rows={rows}
                title={title}
                defaultSortFieldId={defaultSortFieldId}
                defaultOrder={defaultOrder}
                onClickLoadMore={onClickLoadMore}
                rowHeight={rowHeight}
            />
        );
    } else if (variant === CustomTableVariants.WITH_PAGINATION) {
        return (
            <CustomTableWithPagination
                columns={columns}
                rows={rows}
                title={title}
                defaultSortFieldId={defaultSortFieldId}
                customRowsPerPage={customRowsPerPage}
                defaultOrder={defaultOrder}
            />
        );
    } else if (variant === CustomTableVariants.WITHOUT_PAGINATION) {
        return (
            <CustomTableWithLoadMore
                columns={columns}
                rows={rows}
                title={title}
                defaultSortFieldId={defaultSortFieldId}
                hideLoadMore={true}
                rowHeight={rowHeight}
                defaultOrder={defaultOrder}
                tableSx={tableSx}
            />
        );
    } else {
        return null;
    }
};

export default CustomTable;
